import { ColDef } from 'ag-grid-enterprise';

import { buildColDef, ColType } from 'app/shared/utils/ag-grid.col-def.utils';

const _size = (size :number) :Partial<ColDef> => ({
  flex: size,
  minWidth: size * 20,
});

export const STOCK_SNAPSHOT_TABLE_COL_DEFS :ColDef[] = [
  buildColDef(ColType.DEFAULT, {
    headerName: 'SKU',
    field: 'sku',
    ..._size(5),
    maxWidth: 200,
  }),
  buildColDef(ColType.DEFAULT, {
    headerName: 'Product Name',
    field: 'productName',
    ..._size(9),
  }),
  buildColDef(ColType.DEFAULT, {
    headerName: 'Warehouse',
    field: 'locationName',
    ..._size(6),
    filter: false,
  }),
  buildColDef(ColType.QUANTITY, {
    headerName: 'On-Hand Qty.',
    field: 'mostRecentRunningBalance',
    ..._size(3),
    maxWidth: 160,
    filter: false,
  }),
  buildColDef(ColType.UOM, {
    headerName: 'UOM',
    field: 'defaultPurchaseUnitName',
    ..._size(6),
    maxWidth: 160,
    filter: false,
    sortable: false,
  }),
  buildColDef(ColType.CURRENCY, {
    headerName: 'On-Hand Value',
    field: 'remainingQuantityCost',
    ..._size(4),
    maxWidth: 160,
    filter: false,
  }),
  buildColDef(ColType.QUANTITY, {
    headerName: 'Incoming Qty.',
    field: 'mostRecentIncomingBalance',
    ..._size(3),
    maxWidth: 160,
    hide: true,
    filter: false,
  }),
  buildColDef(ColType.DEFAULT, {
    headerName: 'Category',
    field: 'categoryName',
    ..._size(9),
    filter: false,
  }),
  buildColDef(ColType.DEFAULT, {
    headerName: 'Subcategory',
    field: 'subCategoryName',
    ..._size(9),
    filter: false,
  }),
];

export const STOCK_SNAPSHOT_AG_GRID_OPTIONS = {
  sideBar: {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
          suppressSideButtons: true,
          suppressColumnSelectAll: true,
          suppressColumnExpandAll: true,
        },
      },
    ],
    defaultToolPanel: '',
  },
  suppressAutoSize: false,
};
